import Vue from "vue";

export const filterNumber = (value: string | number | null, defaultValue = "1"): string => {
  if (typeof value === "number") {
    return value.toString();
  }
  if (!value || isNaN(parseFloat(value))) return defaultValue;
  return parseFloat(value.replace(" ", "").replace(",", ".")).toString();
};

Vue.filter("number", filterNumber);
